import { Component, Injectable, OnInit } from '@angular/core';
import { ApplicationItem } from '../../model/ApplicationItem';
import { ConfigurationService } from '../../services/configuration.service';
import { UrlService } from '../../../shared/services/url.service';
import { AlertService } from '../../../shared/alert/services/alert.service';
import { ApplicationRequest } from '../../model/ApplicationRequest';
import { ValueItem } from '../../model/ValueItem';

@Component({
    selector: 'app-configuration',
    templateUrl: '../templates/configuration.component.html'
})
@Injectable()
export class ConfigurationComponent implements OnInit {
  DashboardUrl = '';
  Applications: ApplicationItem[];
  Application = this.emptyApplication();
  Value = this.emptyValue();

  constructor(
    private configurationService: ConfigurationService,
    private alertService: AlertService,
    private urlService: UrlService) { }

  ngOnInit() {
    this.DashboardUrl = this.urlService.GetDashboardRoute();
    this.initModel();
  }

  OnSaveValue(event: { isSuccess: boolean; data?: any }) {
    event.isSuccess ? this.saveValueSuccess() : this.saveValueFailure(event.data);
  }

  OnSaveApplication(event: { isSuccess: boolean; data?: any }) {
    event.isSuccess ? this.saveApplicationSuccess() : this.saveApplicationFailure(event.data);
  }

  private initModel() {
    this.configurationService.GetApplications().subscribe(applications => {
      this.Applications = applications;
    });
  }

  private saveValueSuccess() {
    this.alertService.add('success', `Value "${this.Value.Key}" has been saved.`);
    this.Value = this.emptyValue(true);
  }

  private saveApplicationSuccess() {
    this.alertService.add('success', `Application "${this.Application.Name}" has been created.`);
    this.Application = this.emptyApplication();
  }

  private saveApplicationFailure(err: any) {
    this.alertService.add('danger', 'Save Application error: ' + err);
  }

  private saveValueFailure(err: any) {
    this.alertService.add('danger', 'Save Value error: ' + err);
  }

  private emptyApplication() {
    return {
      Id: '',
      Name: '',
      Description: '',
      ConfigurationRefreshMinute: 3
    } as ApplicationRequest;
  }

  private emptyValue(keepApplication = false) {
    return  {
      Key: '',
      Value: '',
      Application: {
        Id: keepApplication ? this.Value.Application.Id : ''
      } as ApplicationItem
    } as ValueItem;
  }
}



// WEBPACK FOOTER //
// ./src/app/configuration/components/scripts/configuration.component.ts